export const maskPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/^(.*)\d{3}$/i, '$1XXX');
};
